<template>
  <div class="checkbox">
    <el-checkbox
      :value="checked"
      @change="change"
    >{{ label }}</el-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object,
  },
  computed: {
    label() {
      return this.tableData.title || ''
    },
    checked() {
      return this.scope.row[this.tableData.bind]
    },
  },
  data() {
    return {
      // checked: false
    }
  },
  methods: {
    change(val) {
      let { scope, tableData } = this
      tableData.change(val, scope.row)
    },
  },
}
</script>

<style></style>
